import { createStore, applyMiddleware, compose } from "redux";
import thunkMiddleware from "redux-thunk";
import { createBrowserHistory } from "history";
import { routerMiddleware } from "react-router-redux";
// TODO Raven though requires stripping a lot of action data
// TODO import createRavenMiddleware from 'raven-for-redux';

import rootReducer from "./reducers";
import promiseMiddleware from "./middleware/promise";

// Create a history of your choosing (we're using a browser history in this case)
const history = createBrowserHistory();

// ======================================================
// Store Enhancers
// ======================================================
const enhancers = [];
if (process.env.NODE_ENV === "development" || document.location.host.indexOf(".localhost")) {
  if (typeof window.__REDUX_DEVTOOLS_EXTENSION__ === "function") {
    enhancers.push(window.__REDUX_DEVTOOLS_EXTENSION__());
  }
}

let store = null;
export const initStore = (initialState = {}) => {
  if (store) {
    return store;
  }
  const middleware = [promiseMiddleware, thunkMiddleware, routerMiddleware(history)];
  // if (window.Raven) {
  //   middleware.push(createRavenMiddleware(window.Raven, {}));
  // }
  store = createStore(
    rootReducer(),
    initialState,
    compose(
      applyMiddleware(...middleware),
      ...enhancers
    )
  );
  store.asyncReducers = {};
  store.reduxFormReducerPlugins = {};

  store.history = history;

  if (module.hot) {
    module.hot.accept("./reducers", () => {
      store.replaceReducer(rootReducer(store.asyncReducers, store.reduxFormReducerPlugins));
    });
  }
  return store;
};

export const getStore = () => store;

export default initStore;
